// extracted by mini-css-extract-plugin
module.exports = {"title":"new-module--title--y3NLs","flyerLink":"new-module--flyerLink--B9MAS","arrow":"new-module--arrow--10jrF","sdb":"new-module--sdb--LdAdh"};